module.exports = __webpack_public_path__ + "img/unicorn-display.e04adfe9.png";